import { Button } from "@mui/material";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import RugianoProjectBlocksForm from "components/form/RugianoProjectBlocksForm";
import RugianoProjectForm from "components/form/RugianoProjectForm";

import { SaveContextProvider } from "context/save";

import { useProjectId } from "hooks/useId";
import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Progetto modificata con successo",
        errorMsg: "Errore nella modifica della progetto",
    });

    return (
        <GridItem>
            <GridRow justifyContent={"right"}>
                <GridItem>
                    <Button variant={"contained"} onClick={onButtonClick}>
                        Salva
                    </Button>
                </GridItem>
            </GridRow>
        </GridItem>
    );
}

function ModificaProgettoRugiano() {
    const projectId = useProjectId();

    return (
        <GridColumn className={"product-page"}>
            <SaveContextProvider>
                <GridRow justifyContent={"space-between"} alignItems={"end"}>
                    <GridItem>
                        <GridRow>
                            <GridItem>
                                <h1>Modifica progetto</h1>
                            </GridItem>
                        </GridRow>
                    </GridItem>

                    <GridItem>
                        <ButtonSave />
                    </GridItem>
                </GridRow>

                <RugianoProjectForm projectId={projectId} />

                <RugianoProjectBlocksForm projectId={projectId} />
            </SaveContextProvider>
        </GridColumn>
    );
}

export default ModificaProgettoRugiano;
